/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Filters_FromInputs */

const es_admin_traces_filters_from = /** @type {(inputs: Admin_Traces_Filters_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde`)
};

const en_admin_traces_filters_from = /** @type {(inputs: Admin_Traces_Filters_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Admin_Traces_Filters_FromInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_filters_from = /** @type {((inputs?: Admin_Traces_Filters_FromInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Filters_FromInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_filters_from(inputs)
	return en_admin_traces_filters_from(inputs)
});
export { admin_traces_filters_from as "admin.traces.filters.from" }